export const ChartColors = [
  "#2b59c3",
  "#1d8acf",
  "#16b396",
  "#44c26f",
  "#96c93d",
  "#dcc23f",
  "#472b75",
  "#9c4a88",
  "#d85963",
  "#ef7d3b",
  "#fe9f27",
  "#f5d6ba",
];
